module.exports = __webpack_public_path__ + "static/media/foobar.6396a6ca.png";